<template>
  <el-upload
    class="video-uploader"
    action="#"
    accept="video/*"
    :auto-upload="false"
    :show-file-list="false"
    :on-change="bindUploadChange"
    :disabled="disabled"
  >
    <qm-button slot="default" :text="text" :disabled="disabled" />
  </el-upload>
</template>

<script>
import * as qiniu from 'qiniu-js'
import * as api from 'src/api/index'
import * as qm from 'src/utils/utils'

export default {
  name: 'QmVideoUploader',
  props: {
    text: {
      type: String,
      default: '上传视频',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      media: null,
      file: null,
    }
  },
  computed: {},
  async created() {},
  mounted() {},
  methods: {
    async bindUploadChange(file) {
      await this.initMedia()
      this.$emit('callback', 'start', {
        media: this.media,
        file: file.raw,
      })
      this.file = file.raw
      this.bindUpload()
    },
    // 上传
    async bindUpload() {
      const {file, media} = this
      file.key = media.key
      Sea.upload(qiniu, file, media.token, (name, event) => {
        this.$emit('callback', name, event)
        if (name === 'complete') {
          this.$message.success('上传成功')
        } else if (name === 'error') {
          this.$message.error('上传失败')
        }
      })
    },
    async initMedia() {
      const res = await api.Ajax({
        url: '/v2/cubita.media.create',
        data: {
          type: 'video',
          name: '视频文件',
        },
      })
      if (res.ok && res.media) {
        this.media = res.media
      } else {
        this.$message.error('获取上传密钥失败')
      }
    },
  },
}
</script>

<style lang="stylus">
.video-uploader {
}
</style>
